import React from 'react';
import UiContext from '../../context/UiContext';


const withUiContext = Component => {
	return props => {
		return (
			<UiContext.Consumer>
				{value => {
					return <Component {...props} ctx={value} />;
				}}
			</UiContext.Consumer>
		);
	};
};

export default withUiContext;